export enum AnonymousPost {
  DISABLED = 0,
  ENABLED = 1,
}

export const AnonymousPostEnum: Record<AnonymousPost, string> = {
  [AnonymousPost.DISABLED]: '許可しない',
  [AnonymousPost.ENABLED]: '許可する',
};
